import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {delay, distinctUntilChanged, first, takeUntil, tap} from "rxjs/operators";
import {select, Store} from "@ngrx/store";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../shared/services/filter.service";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {BankFiles} from "../../../shared/interface/bankFiles";
import {BankFilesService} from "../../../shared/services/bank-files.service";
import {NgForm} from "@angular/forms";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-all-bank-files-list',
  templateUrl: './all-bank-files-list.component.html',
  styleUrls: ['./all-bank-files-list.component.scss']
})
export class AllBankFilesListComponent implements AfterViewInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  bankFiles: BankFiles[] = [];
  displayedColumns: string[] = ['createdAt', 'company', 'user', 'numberOfFiles', 'download', 'delete'];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private bankFilesService: BankFilesService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.bankFilesService.getBankFilesListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<BankFiles>) => {
          this.bankFiles = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();

  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      gte$createdAt: 'date',
      lte$createdAt: 'date',
    }, filters);
  }
  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};
    return filters;
  }
  loadListData(): void {
    this.bankFilesService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters());
  }

  filter(): void {

    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  download(uuid: string): void {
    this.bankFilesService.downloadImportFile(uuid);
  }

  delete(uuid: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć plik do banku?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bankFilesService.delete(uuid)
          .subscribe(() => {
            this.loadListData();
            this.snack.open('Pomyślnie usunięto plik do banku', '', {duration: 2000});
          });
      }
    });
  }

}
